<template>
    <div>
        <CreateWarehouse />
    </div>
</template>

<script>
import CreateWarehouse from '@/components/warehouse/CreateWarehouse.vue';
export default {
    components: {
        CreateWarehouse
    },
    name: 'WarehouseCreate'
}
</script>